<template>
    <div class="signInfo oderDet">
        <p class="info_title">订单详情</p>
        <div class="orderTop">
            <div class="o_img">
                <img :src="eventinfo.coveratturl" alt="">
                <span>{{eventinfo.title}}</span>
            </div>
            <p><img :src="detTime" alt=""> {{eventinfo.begintime}}-{{eventinfo.endtime}}</p>
            <p class="address"><img :src="detAddr" alt=""> {{eventinfo.address}}</p>
            <div class="flex_order">
                <p><span>票种名称</span><span>{{eventticketinfo.name}}</span></p>
                <p><span>票种张数</span><span>{{eventticketinfo.ticketcount}}张</span></p>
                <p><span>票种单价</span><span>￥{{eventticketinfo.uprice}}</span></p>
                <p class="money"><span>实付金额</span><span>￥{{eventticketinfo.allprice}}</span></p>
                <div class="submitOrder"><el-button type="primary" @click="submit_order">提交订单</el-button></div>
            </div>
        </div>
        <div class="orderTop orderBot">
            <p class="title">付款说明</p>
            <p>1.付款完成后您将收到［鲸活动］的电子票号及二维码链接，参加活动时请出示二维码凭证（手机开启或打印）或者短信。</p>
            <p>2.如果您需要支付电子票的发票，请于参加活动时向活动主办人索取。</p>
            <p>3.付款完成后如果有收到电子票短信，您可以进入移动端活动页面查询并打印，或者联系鲸活动客服。</p>
            <p class="title padding20">退票指南</p>
            <p>{{eventinfo.isrefund==1?'活动开始前支持退款':'该活动不支持退款'}}</p>
        </div>
    </div>
</template>

<script>
    import {uploadEventEnrollInfo} from 'api/hdApi'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "oderDet",
        props:['collectinfo','eventinfo','eventticketinfo','formList'],
        data(){
            return{
                detTime:require('@/common/images/hd/detTime.png'),
                detAddr:require('@/common/images/hd/detAddr.png'),
                demoEvents:[],
                ticketuserjson:[]
            }
        },
        mounted(){

        },
        methods:{
            submit_order(){
                // this.formList.map(val => {
                //     val.formdata.map(formdata => {
                //         val.formdata.push({
                //             colinnerid:formdata.colinnerid,
                //             colvalue:formdata.colvalue,
                //         });
                //     });
                // });
                // this.ticketuserjson=this.formList;
                const error = this.formList.some(item => item.joinername =='' || item.joinermobile == '');
                // 验证手机号
                // let reg = /^1[0-9]{10}$/;
                // const errPhone = this.formList.some(item => item.joinermobile == '' || item.joinermobile.length<=10||!reg.test(item.joinermobile));
                if(this.collectinfo.iscollectenrollinfo==1&&(this.formList.length!=this.collectinfo.allticketcount)){
                    this.$message({
                        message: '报名人数与票种张数不一致',
                        type: 'warning'
                    });
                }else if(error){
                    this.$message({
                        message: '请填写必填项',
                        type: 'warning'
                    });
                }
                // else if(errPhone){
                //     this.$message({
                //         message: '请输入正确的手机号',
                //         type: 'warning'
                //     });
                // }
                else{
                    let param={
                        eventid:this.$route.query.eventid,
                        ticketnum:this.$route.query.ticketcount,
                        ticketid:this.$route.query.ticketid,
                        ordermoney:this.eventticketinfo.allprice,
                        ticketuserjson:this.formList,
                    };
                    this.setLoading(true);
                    uploadEventEnrollInfo({
                        data: Object.assign({}, param),
                        success: data => {
                            this.setLoading(false);
                            if(data.data.enrollcode==902){ //提交成功-待支付
                                window.location.href=data.data.payurl
                            }else{
                                this.$router.push({name: 'SignResult',query:{orderid:data.data.orderno,ispaysuccess:1}})
                            }
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        }
    }
</script>

<style lang="scss">
    .oderDet{
        width: 490px;
        margin-right: 0;
        .orderTop{
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
            border-radius:6px;
            padding: 20px;
            .o_img{
                display: flex;
                margin-bottom: 20px;
                img{
                    width:154px;
                    height:87px;
                    min-width: 154px;
                    margin-right: 15px;
                }
                span{
                    line-height: 22px;
                    font-size: 16px;
                }
            }
            p{
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #666;
                line-height: 24px;
                img{
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
            }
            .address{
                padding-bottom: 20px;
                padding-top: 10px;
            }
            .flex_order{
                border-top: 1px dashed #E5E5E5;
                p{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;
                    color: #666;
                    font-size: 14px;
                    span:last-child{
                        color: #333;
                    }
                }
                .money{
                    color: #F56C6C;
                    font-size: 16px;
                    span:last-child{
                        color: #F56C6C;
                    }
                }
                .submitOrder{
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 20px;
                    .el-button--primary{
                        width: 120px;
                        background-color: #1464C8;
                        border-color: #1464C8;
                    }
                    .el-button--primary:focus, .el-button--primary:hover{
                        opacity: 0.8;
                    }
                }
            }
        }
        .orderBot{
            margin-top: 20px;
            .title{
                font-size: 16px;
                color: #333;
                padding-bottom: 8px;
            }
            .padding20{
                padding-top: 20px;
            }
        }
    }
</style>